import { _deserializable } from '../_deserializable';

export class ItemAvailabilityRequest extends _deserializable {

  public part: string;
  public qtyOrdered: number;

}
